import { render } from "./MaterialS1.vue?vue&type=template&id=0ebfe640&scoped=true"
import script from "./MaterialS1.vue?vue&type=script&lang=js"
export * from "./MaterialS1.vue?vue&type=script&lang=js"

import "./MaterialS1.vue?vue&type=style&index=0&id=0ebfe640&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ebfe640"]])

export default __exports__